/**
 * Pure string derivation extracted into its own module so the
 * UploadButton can import it without dragging in the markdown
 * pipeline (createProjectFromUpload pulls unified + remark-* via
 * UnifiedMarkdownParser, ~250KB minified).
 */

const MAX_PROJECT_NAME_LEN = 200

export function deriveProjectName(filename: string): string {
  const dot = filename.lastIndexOf('.')
  const base = dot > 0 ? filename.slice(0, dot) : filename
  const trimmed = base.trim()
  const safe = trimmed.length > 0 ? trimmed : filename
  return safe.slice(0, MAX_PROJECT_NAME_LEN)
}
